module.exports = __webpack_public_path__ + "img/ch13_04_海边许愿.2e7bf49e.jpg";